import React,{useState, useEffect} from "react";
import { Tabs,Tab } from "react-bootstrap";
import {getFavouritePrompts} from '../../config/apiConfig';
import RecentPrompts from "./RecentPrompts";
import FavoritePrompts from "./FavouritePrompts";
import ChevronRight from '../../Images/chevronRight.svg';
import ChevronLeft from '../../Images/chevronLeft.svg';
import AddLogo from '../../Images/Add_Logo.svg';
import Home from '../../Images/home.svg';
import CbLogo from '../../Images/CbLogo.svg';
import Button from 'react-bootstrap/Button';
import { sbaAxios } from "../utils/sbaAxios";
import "./Chatbot.css";

function ChatbotSidebar({recents, handleStartNew, setInputText, setRecents,setIsReOrdered}) {
  const [sidebarMini, setSidebarMini] = useState(false);
  const [activeTab,setActiveTab]=useState("Recents");
  const [recentPrompts, setRecentPrompts] = useState([]);
  const [favoritePrompts, setFavoritePrompts] = useState([]);
  const [isReload, setIsReload] = useState(false);

  useEffect(()=>{
    if(recents){
        setRecentPrompts(recents);
    }
  }, [recents]);

  useEffect(()=>{
    GetFavouritePrompts();
  },[recents])

  useEffect(() => {
    if (isReload) {
      console.log('is reload: ', isReload);
      GetFavouritePrompts()
    }
  }, [isReload]);

  const GetFavouritePrompts=async()=>{
      try {
          const favouritePrompts=await sbaAxios({url:getFavouritePrompts});
          //const updatedFavPrompts = favouritePrompts.map((item, index) => {return {...item, sortOrder:index}})
          const sortedPrompts = favouritePrompts.sort((a, b) => a.sortOrder - b.sortOrder);
          setFavoritePrompts(sortedPrompts)
          setIsReload(false);
      } catch (error) {
        setFavoritePrompts([])
        setIsReload(false);
      }
  };

  const handleToggleMiniBar = () => {
    setSidebarMini((prev) => !prev);
  };

  const handleFavoriteAdd = async() => {
    await GetFavouritePrompts();
  };

  const handleFavoriteRemove = async() => {
    await GetFavouritePrompts();
  };

  return (
    <>
      <aside
        className={`cb-sidebar customScrollbar ${
          sidebarMini ? "mini" : "full"
        }  flex-grow-1 p-3`}
      >
        <div className="position-relative mb-5">
          <div className="cb-logo">
            <div className="d-flex gap-3">
              <img
                className="py-2 align-self-start logo-icon"
                src={CbLogo}
                alt="Logo"
              />
              <div className="logo-title">
                <p className="m-0 fs-4 fw-semibold text-dark">Asset Edge AI</p>
                <p className="m-0 fs-6 text-body-secondary">Powered by GenAI</p>
              </div>
            </div>
          </div>
          <div className="toggle-btn bg-transparent border-0 p-0">
            <Button
              type="button"
              className="bg-white"
              onClick={handleToggleMiniBar}
            >
              {sidebarMini ? (
                <img src={ChevronRight} alt="" className="" />
              ) : (
                <img src={ChevronLeft} alt="" className="" />
              )}
            </Button>
          </div>
        </div>
        {/* {/ Menus /} */}
        <div>
          <ul className="menu p-0">
            <li
              className="menu-item"
              onClick={() => {
                //generateClick('dashboard')
              }}
              style={{ pointerEvents: "none" }}
            >
              <span className="menu-item-icon">
                {/* <House strokeWidth={1.5} />  */}
                <img src={Home} alt="Home" />
              </span>
              <span className="menu-item-text">Dashboard</span>
            </li>

            <hr />
          </ul>
        </div>
        <div>
          {sidebarMini ? (
            <>
              <ul className="menu p-0">
                <li
                  className="menu-item primary-bg"
                  onClick={() => handleStartNew("New")}
                >
                  <span className="menu-item-icon">
                    <img
                      src={AddLogo}
                      alt="Start New"
                      onClick={() => handleStartNew("New")}
                    />
                  </span>
                </li>
              </ul>
            </>
          ) : (
            <>
              <div
                className="p-2 pb-3"
                style={{ backgroundColor: "#D3E8F8", borderRadius: "4px" }}
              >
                <h5 className="mb-3 fs-5">Start Exploring</h5>
                <Button
                  className="w-100"
                  style={{
                    backgroundColor: "#3D5A6C", // Background color
                    color: "#FFFFFF", // Text color
                    border: "none", // Removes default border
                  }}
                  onClick={() => handleStartNew("New")}
                >
                  Start New
                </Button>
              </div>
            </>
          )}
        </div>
        {!sidebarMini && (
          <div style={{ marginTop: "16px"  }}>
            <Tabs className="my-3 custom-tabs" defaultActiveKey={activeTab} onSelect={(key)=>{setActiveTab(key)}}>
                <Tab 
                  eventKey="Recents" 
                  title={<span className={activeTab === "Recents" ? "active-tab" : "inactive-tab"}>Recents</span>}
                  onSelect={()=>setActiveTab("Recents")}
                >
                 {activeTab==="Recents" &&<RecentPrompts recentPrompts={recentPrompts} favprompts={favoritePrompts} setInputText={setInputText} setRecentPrompts={setRecents} handleFavoriteAdd={handleFavoriteAdd}/>}
                </Tab>
                <Tab 
                  eventKey="Favourite" 
                  title={<span className={activeTab === "Favourite" ? "active-tab" : "inactive-tab"}>Favorite</span>}
                  onSelect={()=>setActiveTab("Favourite")}
                >
                {activeTab==="Favourite" && <FavoritePrompts setIsReload={setIsReload} handleFavoriteRemove={handleFavoriteRemove} favprompts={favoritePrompts} setInputText={setInputText} setIsReOrdered={setIsReOrdered}/>}
                </Tab>
            </Tabs>
          </div>
        )}
      </aside>
    </>
  );
};

export default ChatbotSidebar;